import React from 'react'
import Dialog from '@mui/material/Dialog'
import moment from 'moment'

import { Avatar, Button } from '../../../../components/UI'

import { getUserName } from '../../../../helpers'

import { classStatuses, imagePrefix } from '../../../../constants'

const CancelClassSuccess = ({ data, open, onClose }) => {
  const classBanner = data?.availability_calendar_detail?.class_banner
  const statusData = classStatuses[data?.status] || classStatuses.cancelled

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'relative md:!max-w-[744px] !p-[32px] !rounded-[10px] !bg-[#FEEBDD]',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img src="/assets/image/booking-cancel-success.svg" alt="Success" />

        <h2 className="mt-[16px] text-[20px] leading-[32px] font-bold text-primary-100 text-center">
          Class has been Cancelled
        </h2>

        <h3 className="text-sm font-medium text-primary-100 text-center mt-[8px]">
          You have cancelled the class booked by Jean Talis.
          <br />
          Please note that you can’t cancel more than 30% of your weekly classes (maximum limit of 5
          classes).
        </h3>

        {classBanner && (
          <div className="px-[70px] w-full mt-[24px]">
            <div className="p-[24px] shadow-modal-light bg-[#FFF5EE] border-[1px] border-[#FFCA84] rounded-[10px] w-full flex flex-col gap-y-[10px]">
              <h4 className="text-base font-bold text-primary-100">Booking Details</h4>

              <div className="w-full flex items-center justify-between">
                <span className="text-base text-primary-100">Class</span>

                <span className="text-base text-primary-100">
                  {classBanner.class_banner_category.name}
                </span>
              </div>

              <div className="w-full flex items-end justify-between">
                <span className="text-base text-primary-100">Schedule</span>

                <span className="text-base text-primary-100">
                  {moment(data?.availability_calendar?.day).format('dddd, MMMM DD - HH:mm')}
                </span>
              </div>

              <div className="w-full flex items-end justify-between">
                <span className="text-base text-primary-100">Tutor</span>

                <div className="flex items-center">
                  <Avatar
                    src={
                      classBanner.class_banner_creator.profile_picture
                        ? `${imagePrefix}${classBanner.class_banner_creator.profile_picture}`
                        : ''
                    }
                    gender={classBanner.class_banner_creator.gender}
                    className="w-[24px] h-[24px] mr-[10px]"
                  />

                  <span className="text-base font-semibold text-primary-100 max-w-[200px] text-ellipsis whitespace-nowrap overflow-hidden">
                    {getUserName(
                      classBanner.class_banner_creator,
                      classBanner.creator_profile?.display_name,
                      classBanner.creator_profile?.display_last_name
                    )}
                  </span>
                </div>
              </div>

              <div className="w-full flex items-end justify-between">
                <span className="text-base text-primary-100">Status</span>

                <span
                  className={`text-base text-white font-bold h-[32px] px-[8px] rounded-[8px] ${statusData?.background || 'bg-black'} flex items-center justify-center`}
                >
                  {statusData?.title}
                </span>
              </div>
            </div>
          </div>
        )}

        <Button
          type="button"
          className="w-full h-[44px] text-lg mt-[24px] leading-[initial]"
          onClick={onClose}
        >
          Continue
        </Button>
      </div>
    </Dialog>
  )
}

export default CancelClassSuccess
